import { combineReducers } from "redux"
// Authentication
//import Login from "./auth/login/reducer"
//sucursales
import Usuario from "./users/registro/reducer"
import Login from "./auth/login/reducer"
import Loader from "./loading/reducer"
import ServiceOrders from "./serviceOrders/reducer"
import Supplier from "./suppliers/reducer"
import NotificationAlert from "./notificationAlerts/reducer"
import Rol from "./rols/reducer"
import Load from "./loads/reducer"
import LoadPayment from "./loadPayments/reducer"
//Configuracion de acciones de titulos y titulo
//import Titles from "./titles/reducer"

const rootReducer = combineReducers({
  Login,
  Usuario,
  Loader,
  ServiceOrders,
  Supplier,
  NotificationAlert,
  Rol,
  Load,
  LoadPayment
})

export default rootReducer
